export default __webpack_public_path__ + "static/media/autolle_logo-black.d50c723f.svg";